import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

function Settings() {
  return (
    <>
      <Navbar />
      <h1>Settings page</h1>
      <Footer />
    </>
  );
}

export default Settings;
